import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { APP_CONFIG, Region } from '../../environment';
import { AuthProvider } from '../authorization';
import { HttpProvider } from '../http/http';
import { LoggerProvider } from '../logger/logger';
import { RouteProvider } from '../route/route';
import { SegmentProvider } from '../../providers/analytics/segment';
import { AppVersionProvider } from '../../providers/app-version/app-version';
import { AnalyticsEventType } from '../../model/types/analytics.const';
import { Platform } from 'ionic-angular';


@Injectable()
export class HelpProvider {
  helpUrlTranslateKey = 'global.linkHelpURL';
  loginHelpUrlTranslateKey = 'global.linkHelpURLAccount';

  constructor(
    private routeProvider: RouteProvider,
    private httpProvider: HttpProvider,
    private translate: TranslateService,
    private analytics: SegmentProvider,
    private appVersionProvider: AppVersionProvider,
  ) { }


  openHelpFallback() {
    const helpUrl = this.translate.instant(this.helpUrlTranslateKey);
    if (helpUrl === (this.helpUrlTranslateKey + ' NOT FOUND') || !helpUrl)
      this.routeProvider.openModal(this.routeProvider.pages.HelpPage, { modal: true });
    else
      this.routeProvider.openIab(helpUrl, null, true, true)
  }
  async openHelp(walletInfo=null) {
    /* Track Help accessed */
    const location = this.routeProvider.getLastActivePage();
    const appVersion = await this.appVersionProvider.getVersionNumber();
    let analyticsData = {location: location, version: appVersion};
    if(walletInfo){
      if(walletInfo.walletBalance){
        delete walletInfo.walletBalance;
      }
      if(walletInfo.walletBalanceLimit){
        delete walletInfo.walletBalanceLimit;
      }
      analyticsData = {...walletInfo, ...analyticsData};
    } else{
      delete analyticsData.version;
    }
    this.analytics.trackEvent({eventName: AnalyticsEventType.HelpAccessed, analyticsData: {
      ...analyticsData,
      location: this.routeProvider.getLastActivePage(),
      country: APP_CONFIG.region.defaultCountryFrom
    }});
    if (AuthProvider.isLoggedIn() && this.httpProvider.getAuthEmail() && APP_CONFIG.region.defaultCountryFrom !== Region.SN)
      this.openHelpSSO();
    else
      this.openHelpFallback();
  }

  openLoginHelp() {
    /* Track Help accessed */
    this.analytics.trackEvent({eventName: AnalyticsEventType.HelpAccessed, analyticsData: {
      location: this.routeProvider.getLastActivePage(),
      country: APP_CONFIG.region.defaultCountryFrom
    }});

    const helpUrl = this.translate.instant(this.loginHelpUrlTranslateKey);
    if (helpUrl === (this.helpUrlTranslateKey + ' NOT FOUND') || !helpUrl)
      this.routeProvider.openModal(this.routeProvider.pages.HelpPage, { modal: true });
    else
      this.routeProvider.openIab(helpUrl, null, true, true)
  }

  async openHelpSSO(){
    AuthProvider.allowRelogin = true;
    try{
      const result = await this.getZendeskSSO();
      if(result && result.ZendeskRedirectUrl){
        this.routeProvider.openIab(result.ZendeskRedirectUrl, null, true, true);
        LoggerProvider.info(this, 'Zendesk SSO Success ', result.ZendeskRedirectUrl)
      } 
    } catch(err){
        LoggerProvider.info(this, 'Zendesk SSO Failed.')
        this.openHelpFallback();
    }
  }

  async createHelpLink(redirectLink : string) {
    let finalURL = redirectLink;
    const helpURLArray = finalURL.split("hc")
    if (helpURLArray.length > 1) {
      const result = await this.getZendeskSSO();
      if (result && result.ZendeskRedirectUrl) {
        const urlSubString = helpURLArray[1].slice(6);
        finalURL = `${result.ZendeskRedirectUrl}${urlSubString}`;
      }
    }
    return finalURL;
  }

  async getZendeskSSO(): Promise<any> {
    return this.httpProvider.get(APP_CONFIG.API_URL + 'api/zendesk/helpcenter');
  }
}


// WEBPACK FOOTER //
// ./src/providers/help/help.ts